import { makeStyles  } from '@material-ui/core/styles';
import {
    Button,
    Grid,
    TableContainer,
    Divider,
    Typography,
} from '@material-ui/core';
import moment from 'moment';

import { useStylesAuth } from '../../../styles/auth/style';
import { TRAMITE_COMPROBANTE_DOCUMENTO } from '../../../utils/constants';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 30,
    },
    align: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    alignDatos: {
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    text:{ 
        width:'100%',
        border: '1px solid #ccc',
        borderRadius: '.3em',
        textAlign: 'center' 
    },
    textObservaciones:{ 
        width:'100%',
        border: '1px solid #ccc',
        borderRadius: '.5em',
        textAlign: 'left',
        padding: '1em',
        wordBreak: 'break-word'
    },
  }));

export const FormatoImpresionComprobanteDocumento = ({comprobante, handleClose, handlePrintRow, componentRef, modal}) => {
    const classes = useStyles();
    const classesAuth = useStylesAuth("light");

    const esEmbargo = comprobante.idTramite === TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO

    return (
        <>
            <TableContainer className={classes.form}>
                <Grid container spacing={2} ref={componentRef}> 
                    <Grid item xs={12} className={classes.logo}>
                        <Grid 
                            container 
                            justify='center'
                        >
                            <Grid 
                                item 
                                xs={6} 
                                className={classesAuth.imageInherit} 
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginTop: '1em'}}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Fecha de Impresion: {moment().format("DD/MM/YYYY")}</Typography> 
                            </Grid>
                            <Grid item xs={12} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Recepción Nro: {comprobante?.idExpediente}</Typography> 
                            </Grid>
                            <Grid item xs={12} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Recepción Nro Sistema Viejo: {comprobante?.idExpedientes}</Typography> 
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginBottom: '2em'}}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'center'}}>
                        <Grid container spacing={2} justify='space-evenly' alignItems='flex-end'>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Fecha de Recepción:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {moment(comprobante?.fechaRecepcion).format("DD/MM/YYYY")}
                                </Typography> 
                            </Grid>
                            {!esEmbargo && (
                                <Grid item xs={4} className={classes.alignDatos}>
                                    <Typography>Fecha Carta:</Typography> 
                                    <Typography variant='overline' className={classes.text}>
                                        {moment(comprobante?.fechaCarta).format("DD/MM/YYYY")}
                                    </Typography>  
                                </Grid>
                            )}
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Usuario Ingreso:</Typography> 
                                <Typography variant='overline' className={classes.text}>{comprobante?.nombreUsuarioCarga}</Typography> 
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '1em'}}>
                                <Divider variant="middle" />
                            </Grid>
                            {esEmbargo ? (
                                <Grid item xs={5} className={classes.alignDatos}>
                                    <Typography>Cuit:</Typography> 
                                    <Typography variant='overline' className={classes.text}>
                                        {comprobante?.cuit === "" ? "-" : comprobante?.cuit}
                                    </Typography> 
                                </Grid>
                            ) : (
                                <Grid item xs={5} className={classes.alignDatos}>
                                    <Typography>Folios:</Typography> 
                                    <Typography variant='overline' className={classes.text}>
                                        {comprobante?.folios === "" ? "-" : comprobante?.folios}
                                    </Typography> 
                                </Grid>
                            )}
                            <Grid item xs={5} className={classes.alignDatos}>
                                <Typography>Procedencia:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {comprobante?.descripcionProcedencia}    
                                </Typography> 
                            </Grid>
                            {esEmbargo ? (
                                <>
                                    <Grid item xs={5} className={classes.alignDatos}>
                                        <Typography>CBU Embargo:</Typography> 
                                        <Typography variant='overline' className={classes.text}>
                                            {comprobante?.cbuEmbargo === '' ? '-' : comprobante?.cbuEmbargo}
                                        </Typography> 
                                    </Grid>
                                    <Grid item xs={5} className={classes.alignDatos}>
                                        <Typography>Importe:</Typography> 
                                        <Typography variant='overline' className={classes.text}>
                                            {comprobante?.importe === '' ? '-' : comprobante?.importe}
                                        </Typography> 
                                    </Grid>
                                    <Grid item xs={12} style={{marginBottom: '1em'}}>
                                        <Divider variant="middle" />
                                    </Grid>
                                    <Grid item xs={12} className={classes.alignDatos}>
                                        <Typography>Autos:</Typography> 
                                        <Typography variant='overline' className={classes.textObservaciones}>
                                            {comprobante?.autos === '' ? '-' : comprobante?.autos}
                                        </Typography> 
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid item xs={12} style={{marginBottom: '1em'}}>
                                        <Divider variant="middle" />
                                    </Grid>
                                    <Grid item xs={12} className={classes.alignDatos}>
                                        <Typography>Entregado Por:</Typography> 
                                        <Typography variant='overline' className={classes.textObservaciones}>
                                            {comprobante?.entregadoPor === '' ? '-' : comprobante?.entregadoPor}
                                        </Typography> 
                                    </Grid>
                                    <Grid item xs={12} className={classes.alignDatos}>
                                        <Typography>Caratula:</Typography> 
                                        <Typography variant='overline' className={classes.textObservaciones}>
                                            {comprobante?.caratula === '' ? 'No hay caratula.' : comprobante?.caratula}
                                        </Typography> 
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography>Observaciones:</Typography> 
                                <Typography variant='overline' className={classes.textObservaciones}>
                                    {comprobante?.observaciones === '' ? 'No hay observaciones.' : comprobante?.observaciones}
                                </Typography> 
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {modal &&
                    (<Grid item xs={12} style={{ display:'flex', justifyContent:'flex-end', alignItems:'center', marginTop: '1em' }}>
                        <Button style={{marginRight:5}} onClick={handleClose} variant='contained' color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handlePrintRow} variant='contained' color="primary" autoFocus>
                            Imprimir
                        </Button>
                    </Grid>)
                }
            </TableContainer>
        </>
    );
}